import React from 'react'
import styled from 'styled-components'
import { Colors } from '../../constants'
import { Currency } from '../../model'
import { DownChevron } from '../icons'
import { PairImage } from './PairImage'

interface Props {
  currency: Currency
  other: Currency
  onClick: () => void
}

export function PairButton({ currency, other, onClick }: Props) {
  return (
    <Button onClick={onClick}>
      <PairImage currencySymbol={currency.symbol} otherSymbol={other.symbol} />
      {currency.symbol}-{other.symbol}
      <DownChevronStyled />
    </Button>
  )
}

const Button = styled.button`
  display: flex;
  align-items: center;
  color: ${Colors.White};
  font-size: 15px;
  font-weight: bold;
  outline: 0;
  border: 0;
  background: none;
  cursor: pointer;
`

const DownChevronStyled = styled(DownChevron)`
  margin-left: 5px;
  width: 14px;
`
